import React from "react";
import { Volume2, VolumeX, Keyboard } from "lucide-react";

export function Cabinet({ children, settings, title = "TYPEBLASTER" }) {
  return (
    <div className="w-full max-w-4xl h-[94vh] max-h-[860px] bg-[#16152b] border-8 border-[#2a274e] rounded-3xl p-3 sm:p-5 shadow-[0_0_60px_rgba(0,240,255,0.18)] flex flex-col relative">
      {/* Cabinet top bar */}
      <div className="flex items-center justify-between mb-2 px-1">
        <span className="font-arcade text-[10px] sm:text-xs text-cyan-400 text-glow-cyan tracking-widest">
          {title}
        </span>
        <div className="flex items-center gap-2">
          <button
            data-testid="toggle-keyboard-btn"
            onClick={() => settings.setShowKeyboard((v) => !v)}
            title="Toggle finger guide keyboard"
            className={`p-1.5 rounded border-2 transition-all ${
              settings.showKeyboard
                ? "border-[#ffb000] text-[#ffb000]"
                : "border-[#3a366b] text-slate-500"
            }`}
          >
            <Keyboard size={16} />
          </button>
          <button
            data-testid="toggle-sound-btn"
            onClick={settings.toggleSound}
            title="Toggle sound"
            className={`p-1.5 rounded border-2 transition-all ${
              settings.soundOn
                ? "border-[#00f0ff] text-[#00f0ff]"
                : "border-[#3a366b] text-slate-500"
            }`}
          >
            {settings.soundOn ? <Volume2 size={16} /> : <VolumeX size={16} />}
          </button>
        </div>
      </div>

      {/* Screen */}
      <div className="relative flex-1 rounded-2xl border-4 border-[#242242] bg-[#0b0b18] overflow-hidden">
        {children}
      </div>
    </div>
  );
}
